<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img
          :src="
          require('@/assets/nexo.png')"
      />
    </v-list-item-avatar>

    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h3">
        <img src="@/assets/logo.png" width="150">
        <!--        <strong class="mr-1 font-weight-black">NEXO</strong>-->
        <!--        <span class="primary&#45;&#45;text">MED</span>-->
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import {get} from 'vuex-pathify'

export default {
  name: 'DefaultDrawerHeader',

  computed: {version: get('app/version')},
}
</script>
